"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialCategoryList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const form_parts_1 = require("@front/components/form-parts");
const backendImport_1 = require("@front/backendImport");
const acl_helpers_1 = require("@back/app/acl_module/acl.helpers");
const component_2 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="tutorial-category-list-page">
        <div class="page-head">
            <div>
                <h1>${() => 'tutorial.category.list.title'.t()}</h1>
                <p>${() => 'tutorial.category.list.subtitle'.t()}</p>
            </div>
            <div class="btn-group">
                <button class="btn btn-outline-secondary" @click="${x => x.goBack()}" title="${() => 'crud.back'.t()}">
                    <i class="simple-icon-arrow-left"></i>
                </button>
                <button class="btn btn-primary" @click="${x => x.openCreateForm()}">
                    <i class="simple-icon-plus"></i> ${() => 'tutorial.category.create.button'.t()}
                </button>
            </div>
        </div>

        ${(0, fast_element_1.when)(x => x.showForm, (0, fast_element_1.html) `
            <div class="category-form card mb-4">
                <div class="card-body">
                    <h5>${x => x.editingCategory ? 'tutorial.category.edit.title'.t() : 'tutorial.category.create.title'.t()}</h5>
                    <the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
                        <div class="form-group">
                            <part-input 
                                required="true"
                                class="form-part" 
                                label="${'tutorial.category.name'.t()}" 
                                :value="${x => x.form.name}"
                                name="name" 
                                placeholder="${'tutorial.category.namePlaceholder'.t()}"
                            ></part-input>
                        </div>
                        <div class="form-group">
                            <part-textarea 
                                class="form-part" 
                                label="${'tutorial.category.description'.t()}"
                                :value="${x => x.form.description}" 
                                name="description" 
                                rows="3"
                                placeholder="${'tutorial.category.descriptionPlaceholder'.t()}"
                            ></part-textarea>
                        </div>                       
                        <div class="form-group">
                            <div class="form-check">
                                <part-checkbox
                                    class="form-part"
                                    label="${'tutorial.category.isActive'.t()}"
                                    :value="${x => x.form.isActive}"
                                    name="isActive"
                                ></part-checkbox>
                            </div>
                        </div>
                        <div class="form-group mt-4">
                            <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary btn-lg mr-2"
                                ?disabled="${x => x.loading}">
                                <span ?hidden="${x => !x.loading}" class="spinner-border spinner-border-sm me-2"></span>
                                ${x => x.editingCategory ? 'common.update'.t() : 'common.create'.t()}
                            </button>
                            <button type="button" class="btn btn-outline-secondary btn-lg" @click="${x => x.cancelForm()}">
                                ${() => 'crud.cancel'.t()}
                            </button>
                        </div>
                    </the-form>
                </div>
            </div>
        `)}

        <div class="tutorial-category-list-content" ?loading="${x => x.loading}">
            ${x => x.loading ?
    (0, fast_element_1.html) `<div class="loading-spinner">${() => 'common.loading'.t()}</div>` :
    x.data.length > 0 ?
        (0, fast_element_1.html) `<div class="training-grid">
                        ${(0, fast_element_1.repeat)(x => x.data, (0, fast_element_1.html) `
                            <div class="training-card">                          
                                <div class="body">
                                    <h3>${x => x.name}</h3>
                                    <p class="desc">${x => x.description || 'tutorial.noDescription'.t()}</p>
                                </div>
                                <div class="foot">
                                    <button class="btn btn-primary flex-grow-1" @click="${(x, c) => c.parent.editCategory(x)}">
                                        ${() => 'crud.edit'.t()}
                                        <i class="simple-icon-pencil"></i>
                                    </button>
                                    <button class="btn btn-outline-danger" @click="${(x, c) => c.parent.deleteCategory(x)}" title="${() => 'crud.delete'.t()}">
                                        <i class="simple-icon-trash"></i>
                                    </button>
                                </div>
                            </div>
                        `)}
                    </div>` :
        (0, fast_element_1.html) `<div class="empty-state">
                        <i class="simple-icon-tag"></i>
                        <h3>${() => 'tutorial.category.list.empty.title'.t()}</h3>
                        <p>${() => 'tutorial.category.list.empty.message'.t()}</p>
                    </div>`}
        </div>
    </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.tutorial-category-list-page {
  padding: 24px;
}
.tutorial-category-list-page .page-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 24px;
}
.tutorial-category-list-page .page-head h1 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 4px 0;
  color: var(--color-text-primary);
}
.tutorial-category-list-page .page-head p {
  color: var(--color-text-secondary);
  margin: 0;
}
.tutorial-category-list-page .category-form {
  border-color: var(--chat_header_color);
}
.tutorial-category-list-page .category-form .card-body {
  padding: 24px;
}
.tutorial-category-list-page .category-form h5 {
  margin-bottom: 20px;
  color: var(--color-text-primary);
}
.tutorial-category-list-page .category-form .form-label {
  color: var(--color-text-secondary);
  font-weight: 500;
}
.tutorial-category-list-page .category-form .form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -8px;
  margin-left: -8px;
}
.tutorial-category-list-page .category-form .form-row > .form-group {
  padding-right: 8px;
  padding-left: 8px;
}
.tutorial-category-list-page .category-form .form-check {
  padding-left: 0;
}
.tutorial-category-list-page .tutorial-category-list-content {
  min-height: 200px;
}
.tutorial-category-list-page .tutorial-category-list-content[loading] {
  display: flex;
  align-items: center;
  justify-content: center;
}
.tutorial-category-list-page .training-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 22px;
  margin-bottom: 24px;
}
.tutorial-category-list-page .training-card {
  background: #fff;
  border: 1px solid var(--chat_header_color);
  border-radius: var(--border-radius-lg, 14px);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.tutorial-category-list-page .training-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px -22px rgba(31, 44, 85, 0.4);
}
.tutorial-category-list-page .training-card .card-logo {
  position: relative;
  height: 120px;
  display: grid;
  place-items: center;
  background: #fff;
  border-bottom: 1px solid var(--chat_header_color);
}
.tutorial-category-list-page .training-card .card-logo .category-icon {
  font-size: 32px;
}
.tutorial-category-list-page .training-card .card-logo .tutorial-logo-placeholder {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary-light);
  color: var(--color-primary);
  font-size: 28px;
  border-radius: 50%;
}
.tutorial-category-list-page .training-card .badge-cat {
  position: absolute;
  top: 12px;
  right: 12px;
  background: var(--color-primary-light);
  color: var(--color-primary-dark, var(--color-primary));
  border: 1px solid var(--color-primary);
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 2px 9px;
  border-radius: 999px;
}
.tutorial-category-list-page .training-card .body {
  padding: 16px 18px 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}
.tutorial-category-list-page .training-card .body h3 {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0;
  color: var(--color-text-primary);
}
.tutorial-category-list-page .training-card .body .desc {
  color: var(--color-text-secondary);
  font-size: 0.86rem;
  flex: 1;
  margin: 0;
}
.tutorial-category-list-page .training-card .foot {
  padding: 0 18px 18px;
  display: flex;
  gap: 8px;
}
.tutorial-category-list-page .training-card .foot .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.tutorial-category-list-page .empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--color-text-secondary);
}
.tutorial-category-list-page .empty-state i {
  font-size: 48px;
  margin-bottom: 16px;
  color: var(--color-primary);
}
.tutorial-category-list-page .empty-state h3 {
  margin: 0 0 8px 0;
  color: var(--color-text-primary);
}
.tutorial-category-list-page .empty-state p {
  margin: 0 0 24px 0;
}
.tutorial-category-list-page .loading-spinner {
  text-align: center;
  padding: 40px;
  color: var(--color-text-secondary);
}`;
const shadowOptions = { "mode": "open" };
let TutorialCategoryList = class TutorialCategoryList extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.data = [];
        this.loading = false;
        this.showForm = false;
        this.editingCategory = null;
        this.form = {
            name: '',
            description: '',
            color: '#007bff',
            icon: 'simple-icon-folder',
            isActive: true
        };
        this.sendSubmit = form_parts_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadData();
        form_parts_1.FormComponent.listenForValuesChange.bind(this)('form');
    }
    async loadData() {
        try {
            this.loading = true;
            const response = await this.apiService.back.get('tutorial.category.list', { queryParams: { all: '1' } });
            if (response && response.success && Array.isArray(response.data)) {
                this.data = response.data;
            }
            else {
                this.popupService.error((response === null || response === void 0 ? void 0 : response.error) || 'tutorial.category.loadFailed'.t());
            }
        }
        catch (error) {
            console.error('Failed to load tutorial categories:', error);
            this.popupService.error('tutorial.category.loadFailed'.t());
        }
        finally {
            this.loading = false;
        }
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/tutorial');
    }
    openCreateForm() {
        this.editingCategory = null;
        this.form = {
            name: '',
            description: '',
            color: '#007bff',
            icon: 'simple-icon-folder',
            isActive: true
        };
        this.showForm = true;
    }
    editCategory(category) {
        this.editingCategory = category;
        this.form = {
            name: category.name || '',
            description: category.description || '',
            color: category.color || '#007bff',
            icon: category.icon || 'simple-icon-folder',
            isActive: category.isActive !== false
        };
        this.showForm = true;
    }
    cancelForm() {
        this.showForm = false;
        this.editingCategory = null;
        this.form = {
            name: '',
            description: '',
            color: '#007bff',
            icon: 'simple-icon-folder',
            isActive: true
        };
    }
    async sendForm(event) {
        event.preventDefault();
        if (!this.form.name.trim()) {
            this.popupService.error('tutorial.category.nameRequired'.t());
            return;
        }
        try {
            this.loading = true;
            let response;
            if (this.editingCategory) {
                response = await this.apiService.back.put('tutorial.category.update', this.form, {
                    routeParams: { id: this.editingCategory.id }
                });
            }
            else {
                response = await this.apiService.back.post('tutorial.category.create', this.form);
            }
            if (response && response.success) {
                this.notifyService.notify(this.editingCategory ? 'tutorial.category.updateSuccess'.t() : 'tutorial.category.createSuccess'.t());
                this.cancelForm();
                await this.loadData();
            }
            else {
                this.popupService.error((response === null || response === void 0 ? void 0 : response.error) || 'tutorial.category.saveFailed'.t());
            }
        }
        catch (error) {
            console.error('Failed to save tutorial category:', error);
            this.popupService.error('tutorial.category.saveFailed'.t());
        }
        finally {
            this.loading = false;
        }
    }
    handleIconChange(event) {
        const { value } = event.detail;
        this.form.icon = value || '';
    }
    async deleteCategory(category) {
        const confirmed = await this.popupService.confirm('tutorial.category.delete.confirmText'.t(), false, 'tutorial.category.delete.confirm'.t());
        if (confirmed) {
            try {
                const response = await this.apiService.back.delete('tutorial.category.delete', {
                    routeParams: { id: category.id }
                });
                if (response.success) {
                    this.notifyService.notify('tutorial.category.delete.success'.t());
                    await this.loadData();
                }
                else {
                    this.popupService.error(response.error || 'tutorial.category.deleteFailed'.t());
                }
            }
            catch (error) {
                console.error('Failed to delete tutorial category:', error);
                this.popupService.error('tutorial.category.deleteFailed'.t());
            }
        }
    }
    canManage() {
        const user = component_2.DefaultLayout.USER;
        if (!user)
            return false;
        return user.role === backendImport_1.UserRoles.SUPER_ADMIN || user.role === backendImport_1.UserRoles.PARENT_USER || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.write}`, user.acl);
    }
};
exports.TutorialCategoryList = TutorialCategoryList;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialCategoryList.prototype, "data", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialCategoryList.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialCategoryList.prototype, "showForm", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialCategoryList.prototype, "editingCategory", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialCategoryList.prototype, "form", void 0);
exports.TutorialCategoryList = TutorialCategoryList = __decorate([
    (0, client_1.RWSView)('tutorial-category-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], TutorialCategoryList);
TutorialCategoryList.defineComponent();
